import { render, staticRenderFns } from "./SesiProfileSettings.vue?vue&type=template&id=6b2f9af0&scoped=true&"
import script from "./SesiProfileSettings.vue?vue&type=script&lang=js&"
export * from "./SesiProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./SesiProfileSettings.vue?vue&type=style&index=0&id=6b2f9af0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f9af0",
  null
  
)

export default component.exports